import { ENV_VARS } from '@/env';
import { Drawer as ADrawer, Col, type DrawerProps, Row } from 'antd';
import type { FC, ReactNode } from 'react';
import { ReactComponent as Close } from '../../../assets/icons/close-white.svg';
import IconButton from '../Buttons/IconButton';

interface DrawerCustomProps extends DrawerProps {
  headerContents: ReactNode;
  classFieldName?: string;
  contentClassName?: string;
  dataTestId?: string;
  visible: boolean; // TODO: visible is deprecated
}

const Drawer: FC<DrawerCustomProps> = ({
  visible = false,
  children,
  onClose = () => {},
  headerContents = '',
  classFieldName = '',
  width = '70%',
  afterOpenChange = () => {},
  contentClassName = '',
  destroyOnClose = false,
  forceRender = false,
  dataTestId = '',
}) => {
  const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';

  return (
    <ADrawer
      className="shipment-drawer-container"
      placement="right"
      open={visible}
      styles={{ wrapper: { width: `${width}` } }}
      onClose={() => {}}
      afterOpenChange={afterOpenChange}
      destroyOnClose={destroyOnClose}
      forceRender={forceRender}
      data-testid={dataTestId}
    >
      <div className="vh-100 d-flex flex-direction-column overflow-y-inherit">
        <div
          className={`${classFieldName} ${
            isHBUser ? 'hb-bg-color' : ''
          } py-16 px-30 background-header filter-shadow border-none `}
        >
          <Row justify="space-between" className="align-items-center">
            <Col className="flex-1">{headerContents}</Col>
            <Col className="d-flex">
              <IconButton onClick={onClose}>
                <Close />
              </IconButton>
            </Col>
          </Row>
        </div>
        <div className={`${contentClassName} h-100 overflow-hidden flex-1`}>{children}</div>
      </div>
    </ADrawer>
  );
};

export default Drawer;
